import { DEFAULT_VARIANT, Icon } from "../Icon.js";
import { jsx } from "react/jsx-runtime";
import { useTranslation } from "react-i18next";

//#region src/components/icon/variants/IconLock.tsx
const OutlinedFilledLock = (props) => /* @__PURE__ */ jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 -960 960 960",
	...props,
	children: /* @__PURE__ */ jsx("path", { d: "M229-57q-38.78 0-66.39-27.61T135-151v-416q0-39.19 27.61-67.09Q190.22-662 229-662h50v-74q0-85.19 58.37-144.59Q395.73-940 479.87-940q84.13 0 142.63 59.41Q681-821.19 681-736v74h50q39.19 0 67.09 27.91Q826-606.19 826-567v416q0 38.78-27.91 66.39Q770.19-57 731-57H229Zm251.17-225q31.83 0 54.33-22.03T557-357q0-30-22.67-54.5t-54.5-24.5q-31.83 0-54.33 24.5t-22.5 55q0 30.5 22.67 52.5t54.5 22ZM373-662h214v-73.77q0-46.73-30.65-77.98-30.64-31.25-76-31.25Q435-845 404-813.75q-31 31.25-31 77.98V-662Z" })
});
const OutlinedLock = (props) => /* @__PURE__ */ jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 -960 960 960",
	...props,
	children: /* @__PURE__ */ jsx("path", { d: "M229-57q-38.78 0-66.39-27.61T135-151v-416q0-39.19 27.61-67.09Q190.22-662 229-662h50v-74q0-85.19 58.37-144.59Q395.73-940 479.87-940q84.13 0 142.63 59.41Q681-821.19 681-736v74h50q39.19 0 67.09 27.91Q826-606.19 826-567v416q0 38.78-27.91 66.39Q770.19-57 731-57H229Zm0-94h502v-416H229v416Zm251.17-131q31.83 0 54.33-22.03T557-357q0-30-22.67-54.5t-54.5-24.5q-31.83 0-54.33 24.5t-22.5 55q0 30.5 22.67 52.5t54.5 22ZM373-662h214v-73.77q0-46.73-30.65-77.98-30.64-31.25-76-31.25Q435-845 404-813.75q-31 31.25-31 77.98V-662ZM229-151v-416 416Z" })
});
const RoundedFilledLock = (props) => /* @__PURE__ */ jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 -960 960 960",
	...props,
	children: /* @__PURE__ */ jsx("path", { d: "M229-57q-38.78 0-66.39-27.61T135-151v-416q0-39.19 27.61-67.09Q190.22-662 229-662h50v-74q0-85.19 58.37-144.59Q395.73-940 479.87-940q84.13 0 142.63 59.41Q681-821.19 681-736v74h50q39.19 0 67.09 27.91Q826-606.19 826-567v416q0 38.78-27.91 66.39Q770.19-57 731-57H229Zm251.17-225q31.83 0 54.33-22.03T557-357q0-30-22.67-54.5t-54.5-24.5q-31.83 0-54.33 24.5t-22.5 55q0 30.5 22.67 52.5t54.5 22ZM373-662h214v-73.77q0-46.73-30.65-77.98-30.64-31.25-76-31.25Q435-845 404-813.75q-31 31.25-31 77.98V-662Z" })
});
const RoundedLock = (props) => /* @__PURE__ */ jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 -960 960 960",
	...props,
	children: /* @__PURE__ */ jsx("path", { d: "M229-57q-38.78 0-66.39-27.61T135-151v-416q0-39.19 27.61-67.09Q190.22-662 229-662h50v-74q0-85.19 58.37-144.59Q395.73-940 479.87-940q84.13 0 142.63 59.41Q681-821.19 681-736v74h50q39.19 0 67.09 27.91Q826-606.19 826-567v416q0 38.78-27.91 66.39Q770.19-57 731-57H229Zm0-94h502v-416H229v416Zm251.17-131q31.83 0 54.33-22.03T557-357q0-30-22.67-54.5t-54.5-24.5q-31.83 0-54.33 24.5t-22.5 55q0 30.5 22.67 52.5t54.5 22ZM373-662h214v-73.77q0-46.73-30.65-77.98-30.64-31.25-76-31.25Q435-845 404-813.75q-31 31.25-31 77.98V-662ZM229-151v-416 416Z" })
});
const SharpFilledLock = (props) => /* @__PURE__ */ jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 -960 960 960",
	...props,
	children: /* @__PURE__ */ jsx("path", { d: "M135-57v-605h144v-74q0-85.19 58.37-144.59Q395.73-940 479.87-940q84.13 0 142.63 59.41Q681-821.19 681-736v74h145v605H135Zm345.17-225q31.83 0 54.33-22.03T557-357q0-30-22.67-54.5t-54.5-24.5q-31.83 0-54.33 24.5t-22.5 55q0 30.5 22.67 52.5t54.5 22ZM373-662h214v-73.77q0-46.73-30.65-77.98-30.64-31.25-76-31.25Q435-845 404-813.75q-31 31.25-31 77.98V-662Z" })
});
const SharpLock = (props) => /* @__PURE__ */ jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 -960 960 960",
	...props,
	children: /* @__PURE__ */ jsx("path", { d: "M135-57v-605h144v-74q0-85.19 58.37-144.59Q395.73-940 479.87-940q84.13 0 142.63 59.41Q681-821.19 681-736v74h145v605H135Zm94-94h502v-416H229v416Zm251.17-131q31.83 0 54.33-22.03T557-357q0-30-22.67-54.5t-54.5-24.5q-31.83 0-54.33 24.5t-22.5 55q0 30.5 22.67 52.5t54.5 22ZM373-662h214v-73.77q0-46.73-30.65-77.98-30.64-31.25-76-31.25Q435-845 404-813.75q-31 31.25-31 77.98V-662ZM229-151v-416 416Z" })
});
const componentMap = {
	outlined: OutlinedLock,
	"outlined-fill": OutlinedFilledLock,
	rounded: RoundedLock,
	"rounded-fill": RoundedFilledLock,
	sharp: SharpLock,
	"sharp-fill": SharpFilledLock
};
const IconLock = ({ color, filled, height, variant = "rounded", style = {}, width, "data-testid": testId }) => {
	const { t } = useTranslation("pds");
	return /* @__PURE__ */ jsx(Icon, {
		SvgIcon: componentMap[`${variant}${filled ? "-fill" : ""}`] ?? componentMap[DEFAULT_VARIANT],
		alt: t(""),
		"data-testid": testId,
		color,
		style,
		height,
		width
	});
};

//#endregion
export { IconLock };